module.exports = __webpack_public_path__ + "img/29.fd9fa23b.jpg";